import React, { useRef } from "react";
import Editor, { EditorProps } from "@monaco-editor/react";
import { getCurrentMode } from "../utils/queryStringHelper";

export const MonacoControlledEditor = (
    { value, onChange, editorDidMount, ...props }:
        EditorProps & { onChange: (ev: Event, value: string) => string | void }
) => {
    const previousValue = useRef(value);

    const handleEditorDidMount = (getValue: () => string, editor: any) => {
        editor.onDidChangeModelContent((ev: Event) => {
            const currentMode = getCurrentMode();
            if (currentMode === "htmlCode" || currentMode === "jsCode") {
                const currentLanguage = editor.getModel()._languageIdentifier.language;
                const editorMode = currentMode === "htmlCode" ? "html" : "typescript";
                if (currentLanguage !== editorMode) {
                    return;
                }
            }
            const currentValue = editor.getValue();
            if (currentValue !== previousValue.current) {
                previousValue.current = currentValue;
                const value = onChange(ev, currentValue);

                if (typeof value === "string") {
                    if (currentValue !== value) {
                        editor.setValue(value);
                    }
                }
            }
        });
        editor.changeViewZones((changeAccessor: any) => {
            const domNode = document.createElement("div");
            changeAccessor.addZone({
                afterLineNumber: 0,
                heightInPx: 12,
                domNode: domNode
            });
        });
        editor.getModel().updateOptions({ tabSize: 4 });
        if (editorDidMount) {
            editorDidMount(getValue, editor);
        }
    };

    return <Editor
        value={value}
        editorDidMount={handleEditorDidMount}
        options={{
            minimap: { enabled: false },
            hover: { delay: 1000, enabled: true },
            fontSize: "13px",
            tabSize: 4,
            renderLineHighlight: "none",
            renderLineHighlightOnlyWhenFocus: true
        }}
        // _isControlledMode={true}
        {...props}
    />;
};
